/* eslint-disable */
export default {
  all: 'Kaikki',
  company: 'Yritys',
  personal: 'Henkilökohtainen',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
